/**
 * this file contains all redux-saga watchers & workers for the notifications
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Heesien on 20/08/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'
import Cookies from 'js-cookie'

import C from '../constants'
import config from '../config'
import { request, isEmpty, substitute } from '../utility/utilities'

// import action creators
import * as NotificationsActions from '../actions/notificationsActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE NOTIFICATIONS DATA
----------------------------------------------------------------------------- */

// watcher saga for fetching the notifications data
export function* watchFetchNotifications() {
    yield takeEvery(C.FETCH_NOTIFICATIONS_DATA, workerFetchNotifications)
}

// worker saga for fetching the notifications data
function* workerFetchNotifications() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.notificationFetchURL

    try {

        // show the loader
        yield put(NotificationsActions.showNotificationsLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            const notificationsData = response.data

            // set the notifications data
            yield put(NotificationsActions.setNotificationsData(notificationsData))
        }

    } catch (error) {

        // TODO : ??

    } finally {

        // hide the loader regardless
        yield put(NotificationsActions.showNotificationsLoader(false))
    }
}

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO DISMISS NOTIFICATION
----------------------------------------------------------------------------- */

// watcher saga for dismiss notification
export function* watchDismissNotification() {
    yield takeEvery(C.DISMISS_NOTIFICATION, workerDismissNotification)
}

// worker saga for dismiss notification
function* workerDismissNotification(action) {

    const id = action.payload

    // set the headers
    const headers = {
        method: 'POST',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            'X-CSRFToken': Cookies.get('csrftoken')
        },
        mode: 'cors',
        cache: 'default',
        body: JSON.stringify(id)
    }

    // set the endpoint
    const requestURL = substitute(config.endpoints.notificationDismissURL, {id})

    try {

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            const notificationsData = response.data

            // set the notifications data
            yield put(NotificationsActions.setNotificationsData(notificationsData))
        }

    } catch (error) {
        // TODO : ??

    } finally {

    }
}



// WEBPACK FOOTER //
// ./src/sagas/notificationsSaga.js